import { Controller } from "@hotwired/stimulus"

// Simple controller to toggle between truncated and full text
export default class extends Controller {
  static targets = ["short", "full", "moreLink", "lessLink"]

  toggle(event) {
    if (event) event.preventDefault()

    this.shortTarget.classList.toggle("hidden")
    this.fullTarget.classList.toggle("hidden")
    this.moreLinkTarget.classList.toggle("hidden")
    this.lessLinkTarget.classList.toggle("hidden")
  }
}
